import getRefreshToken from './getRefreshToken';

export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID;
export const SECRET = import.meta.env.VITE_SECRET;

export const ERROR_400 = 'invalid_grant';
const HTTP_STATUS_UNAUTHORIZED = 401;
const RETRY_DELAY_MS = 3000;

export const CONFIG = {
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': 'Origin',
  },
};

export const handleAxiosSuccess = (response) => {
  return {
    data: response.data,
    codeHTTP: response.status,
  };
};

//This project does't logout, It stay log in all time
export const handleAxiosError = async ({ method, apiPath, params, data, error }) => {
  if (error && error.response.status === HTTP_STATUS_UNAUTHORIZED) {
    const res = await getRefreshToken({ method, apiPath, params, data });

    return res;
  } else if (error) {
    return {
      data: error.response.data,
      codeHTTP: error.response.status,
    };
  } else {
    return error;
  }
};

export const redirectToLogin = () => {
  sessionStorage.clear();
  window.location.replace(import.meta.env.VITE_AUTH_REDIRECT_URL);
};

export async function checkError(result, api, ...params) {
  if (result.codeHTTP == HTTP_STATUS_UNAUTHORIZED) {
    return getRefreshToken({ listApi: api });
  }

  if([400, 404].includes(result.codeHTTP)) {
    return {
      data: result.data,
      codeHTTP: result.codeHTTP,
    }
  }

  setTimeout(() => api(...params), RETRY_DELAY_MS);
}
